<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        advanced
        :resource="$sdk.ratecard"
        :primary-fields="[ 'carrier', 'type', 'date_start', 'date_end', 'active', 'charge_account' ]"
        :setup-fields="{ 'group.indices.account': setupGroupIndicesAccountFilterable, date_end: setupDateEndFilterable }"
        :hidden-fields="[ 'group', 'group.indices.account' ]"
        @ready="$refs.table.loadTable()"
        @apply="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <RateCardsTable
          ref="table"
          :filters="filters"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import RateCardsTable from '@/components/Application/Manage/RateCards/RateCardsTable'
import Filter, { IS, IS_GREATER_THAN } from '@/plugins/sdk/Filter'

export default {
  components: {
    Filters,
    RateCardsTable
  },
  data () {
    return {
      title: 'Rate Cards',
      breadcrumb: {
        name: 'Rate Cards',
        route: { name: 'manage-accounts-account-ratecards' }
      },
      actions: [],
      filters: [
        new Filter('group.indices.account', IS, this.$route.params.accountId)
      ]
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  },
  methods: {
    setupDateEndFilterable (filterable) {
      filterable.filter.operator = IS_GREATER_THAN
      filterable.filter.value = this.$moment().startOf('day').toDate()
    },
    setupGroupIndicesAccountFilterable (filterable) {
      filterable.filter.operator = IS
      filterable.filter.value = this.$route.params.accountId
    }
  }
}
</script>
